import { ShowCardAction, setProperty } from 'adaptivecards';

export default class CustomShowCardAction extends ShowCardAction {
    public parse(json: any): void {
        super.parse(json);
        this.isPrimary = json.isPrimary;
    }

    public toJSON(): any {
        let result = super.toJSON();
        setProperty(result, 'isPrimary', this.isPrimary, false);
        return result;
    }
}
